import React, { useState } from "react";
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import MoreMenu from '../Shared/MoreMenu';
import ConfirmDialog from '../Shared/ConfirmDialog';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Api from "../../network/Api";
import SettingsIcon from '@mui/icons-material/Settings';
import { Solution } from "../../types/Solutions";

const ActionMenu = (props: { solution: Solution }) => {
  const [showConfirm, shouldConfirm] = useState<boolean>(false);

  const destroy = () => {
    shouldConfirm(false);
    Api.delete(`/solutions/${props.solution.id}`).then(() => window.location.reload());
  }

  return <>
    <MoreMenu icon={<SettingsIcon />}>
      <MenuItem onClick={() => shouldConfirm(true)}>
        <ListItemIcon><DeleteOutlineIcon fontSize="small" /></ListItemIcon>
        <ListItemText>Delete</ListItemText>
      </MenuItem>
    </MoreMenu>

    { showConfirm && <ConfirmDialog title="Delete solution" 
                                    message="Do you really want to permanently delete this solution?"
                                    destructive
                                    onCancel={() => shouldConfirm(false)}
                                    onConfirm={destroy} /> }
  </>
}

export default ActionMenu;